export const NEXT = 'next';
export const REPLAY = 'replay';
export const RESUME = 'resume';
export const START = 'start';
